import * as React from "react";

const IconFooterLogo: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="96" height="50" viewBox="0 0 96 50" fill="currentColor"><path fill="currentColor" fillRule="evenodd" d="M368.995153,196.52485 L368.995153,224.724355 L359.017048,224.724355 L359.017048,196.52485 L331.86718,196.52485 L364.0061,230 L396.138981,196.52485 L368.995153,196.52485 Z M316,180 L323.229898,187.527963 L404.776142,187.527963 L412,180 L316,180 Z" transform="translate(-316 -180)"/></svg>;
};

export default React.memo(IconFooterLogo);
